import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label } from "reactstrap";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { saudiMobileRules } from "./validationUtils";
import cn from "classnames";
import { useBasicDataQuery } from "../../services/basicData/basicData";

export const MobileField = ({
  control,
  errors,
  watch,
  colSize = "md-4",
  required = true,
  phoneCountryCodeName = "phoneCountryCode",
  phoneName = "phone",
  labelKey = "MOBILE_NUMBER",
  canAmend = true,
}) => {
  const { t } = useTranslation();
  const { data: basicDataRes } = useBasicDataQuery();
  const nationalities = basicDataRes?.data?.data?.nationalities ?? [];

  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <Label
          className={cn("fw-bold", required && canAmend && "required")}
          for={phoneName}
        >
          {t(labelKey)}
        </Label>
        {!canAmend && (
          <span dir="ltr" className="text-start">
            {watch(phoneName)
              ? `${watch(phoneCountryCodeName) || ""}${watch(phoneName) || ""}`
              : "-"}
          </span>
        )}
        {canAmend && (
          <div
            className={cn("mobile-input d-flex align-items-center", {
              "border-danger":
                errors[phoneCountryCodeName] || errors[phoneName],
            })}
          >
            <Controller
              name={phoneName}
              control={control}
              rules={{
                ...(required && { required: t("FIELD_REQUIRED") }),
                ...saudiMobileRules(t),
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  className="mobile border-0 rounded-0"
                  id={phoneName}
                  type="text"
                  placeholder="xxxxxxxxxx"
                  status={errors[phoneName] ? "error" : undefined}
                  onChange={(e) => {
                    field.onChange(e.target.value.replaceAll(" ", ""));
                  }}
                />
              )}
            />
          </div>
        )}
        {(errors[phoneCountryCodeName] || errors[phoneName]) && canAmend && (
          <div className="text-danger mt-1">
            {errors[phoneCountryCodeName]?.message ||
              errors[phoneName]?.message}
          </div>
        )}
      </Stack>
    </Col>
  );
};
